import { InlineLoading } from '@carbon/react';
import { format0 } from 'utils/number';
import styles from './case-coverage-map.module.scss';

interface ValuedCountProps {
  /** Some domain is unassigned. */
  missing: boolean;
  /** Some domain holds an archived scenario (as loaded, or since, per the preview). */
  archived: boolean;
  error: Error | null;
  /** The preview's counts, once ready; null while it loads. */
  counts: { covered: number; total: number } | null;
}

/**
 * Above the map, given a package: how many of its slots this case's picks value, or why that
 * isn't shown yet.
 *
 * @param {ValuedCountProps} props - Why there is no count, or the count.
 * @return {JSX.Element} The line.
 */
export function ValuedCount({
  missing,
  archived,
  error,
  counts,
}: ValuedCountProps) {
  return (
    <div className={styles.valued} data-testid="coverage-valued">
      {missing ? (
        'Assign all 8 domains to see valued slots'
      ) : archived ? (
        'Reassign archived domains to see valued slots'
      ) : error ? (
        `Package coverage unavailable: ${error.message}`
      ) : counts ? (
        <>
          <strong>
            {format0(counts.covered)} of {format0(counts.total)}
          </strong>{' '}
          slots in this package valued
        </>
      ) : (
        <InlineLoading description="Counting the package's valued slots..." />
      )}
    </div>
  );
}
